import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ContactForm from "./sections/ContactForm";

function App() {


  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<ContactForm />} />
    </Routes>
  );
}

export default App;
